//--------------
// Creates a reducer on the fly out of an object map
export function createReducer(initialState, handlers) {
  
  return function reducer(state = initialState, action) {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action)
    } 
    else {
      return state
    }
  }
  
}